export default "/assets/images/accessory-img-03.c1d0bfdd229a82b2.webp";